import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import EventCard from '../components/EventCard';
import AdSlot from '../components/AdSlot';
import { getVenue } from '../api/client';
import styles from './VenuePage.module.css';

export default function VenuePage() {
  const { id } = useParams<{ id: string }>();
  const { data: venue, isLoading, isError } = useQuery({
    queryKey: ['venue', id],
    queryFn: () => getVenue(id!),
    enabled: !!id,
  });

  if (isLoading) return <div className={styles.loading}>Loading…</div>;
  if (isError || !venue) return <div className={styles.error}>Venue not found.</div>;

  return (
    <div className={`container ${styles.page}`}>
      <h1 className={styles.name}>{venue.name}</h1>
      <p className={styles.address}>
        {venue.address}, {venue.city} {venue.state}
        {venue.zip ? ` ${venue.zip}` : ''}
      </p>
      <div className={styles.links}>
        {venue.website && <a href={venue.website} target="_blank" rel="noopener noreferrer">Website</a>}
        {venue.phone && <a href={`tel:${venue.phone}`}>{venue.phone}</a>}
      </div>
      {venue.genreAffinity && <p className={styles.genre}>{venue.genreAffinity} venue</p>}
      {venue.description && <p className={styles.desc}>{venue.description}</p>}

      <h2 className={styles.upcoming}>Upcoming Events</h2>

      {venue.upcomingEvents.length === 0 ? (
        <p className={styles.noEvents}>No upcoming events listed.</p>
      ) : (
        <div className={styles.grid}>
          {venue.upcomingEvents.map((e: any) => (
            <EventCard key={e.id} {...e} venue={{ name: venue.name }} />
          ))}
        </div>
      )}

      <AdSlot type="inline" />

      <p className={styles.suggest}>
        <a href={`/suggest?venue=${encodeURIComponent(venue.name)}`}>Suggest a correction</a>
      </p>
    </div>
  );
}
